import { ShieldCheck, Users, Hammer } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import MapSection from "@/components/MapSection";
import CtaBanner from "@/components/CtaBanner";
import { IMAGES } from "@/constants/site";

const VALUES = [
  {
    icon: Hammer,
    title: "Artigianalità vera",
    desc: "Finiture curate al millimetro, perché i dettagli sono ciò che distingue una casa da un cantiere.",
  },
  {
    icon: Users,
    title: "Squadra interna",
    desc: "Cartongessisti, piastrellisti, idraulici ed elettricisti dipendenti e collaudati, mai subappalti.",
  },
  {
    icon: ShieldCheck,
    title: "Garanzia 10 anni",
    desc: "Ogni lavoro è coperto da garanzia decennale e certificazioni a norma di legge.",
  },
];

export default function ChiSiamo() {
  return (
    <main data-testid="chi-siamo-page">
      <section className="bg-[#F7F5F0] pb-20 pt-36 sm:pt-44">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <Reveal>
            <Overline>Chi Siamo</Overline>
            <h1 className="mt-4 max-w-2xl font-serif text-4xl font-semibold tracking-tight text-[#1A1918] sm:text-5xl lg:text-6xl">
              Artigiani marchigiani,
              <span className="italic text-[#C85A32]"> da quindici anni.</span>
            </h1>
          </Reveal>
        </div>
      </section>

      <section className="bg-[#F7F5F0] pb-24 sm:pb-32">
        <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 sm:px-8 lg:grid-cols-2">
          <Reveal>
            <div className="overflow-hidden rounded-b-2xl rounded-t-[8rem]">
              <img
                src={IMAGES.plastering}
                alt="Artigiano al lavoro in cantiere"
                className="aspect-[4/5] w-full object-cover transition-transform duration-700 hover:scale-105"
              />
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <Overline>La Nostra Storia</Overline>
            <h2 className="mt-4 font-serif text-2xl font-semibold tracking-tight text-[#1A1918] sm:text-3xl lg:text-4xl">
              Nati in cantiere, cresciuti casa dopo casa.
            </h2>
            <div className="mt-6 space-y-5 text-base leading-relaxed text-[#6E6A64]">
              <p>
                RistrutturaCasa nasce a Osimo da un gruppo di maestranze che
                condividevano un'idea semplice: la ristrutturazione non deve
                essere un'odissea per il cliente.
              </p>
              <p>
                Oggi coordiniamo ogni fase — progetto, demolizioni, impianti,
                finiture — con un unico referente e tempi scritti nero su
                bianco. Oltre 250 famiglie ci hanno affidato la loro casa.
              </p>
              <p>
                La nostra promessa è rimasta la stessa del primo giorno:
                cantiere pulito, preventivo chiaro, risultato impeccabile.
              </p>
            </div>
          </Reveal>
        </div>
      </section>

      <section data-testid="values-section" className="bg-[#EFECE6] py-24 sm:py-32">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <Reveal>
            <Overline>I Nostri Valori</Overline>
            <h2 className="mt-4 max-w-lg font-serif text-2xl font-semibold tracking-tight text-[#1A1918] sm:text-3xl lg:text-4xl">
              Ciò in cui crediamo, in ogni cantiere.
            </h2>
          </Reveal>
          <div className="mt-12 grid gap-4 md:grid-cols-3">
            {VALUES.map((v, i) => (
              <Reveal key={v.title} delay={0.1 * i}>
                <article
                  data-testid={`value-card-${v.title.split(" ")[0].toLowerCase()}`}
                  className="h-full rounded-2xl border border-[#1A1918]/10 bg-[#F7F5F0] p-8 transition-colors duration-300 hover:border-[#C85A32]/50"
                >
                  <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[#C85A32] text-[#FAF8F5]">
                    <v.icon size={20} />
                  </span>
                  <h3 className="mt-6 text-xl font-semibold text-[#1A1918] sm:text-2xl">{v.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-[#6E6A64]">{v.desc}</p>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <MapSection light />
      <CtaBanner />
    </main>
  );
}
